import {
  CREATE_FERTILIZATION,
  CREATED_FERTS,
  FERT_COMMENTS,
  FERTILIZATION_DONOR_SCHEDULE,
  FERTILIZATION_TECHS,
  GET_FERTILIZATION_SITES,
  INLINE_FERT_COMMENTS,
  PULLED_SEMEN,
  SCHEDULED_DONORS,
  UPSERT_REVERSE_SORT,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

export const fertilizationAppApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getInlineFertComments: build.query({
      query: () => ({
        document: INLINE_FERT_COMMENTS,
      }),
    }),
    getFertilizationSites: build.query({
      query: () => ({
        document: GET_FERTILIZATION_SITES,
      }),
    }),
    getFertComments: build.query({
      query: () => ({
        document: FERT_COMMENTS,
      }),
    }),
    getCreatedFerts: build.query({
      query: ({ donorScheduleDate, fertSiteId }) => ({
        document: CREATED_FERTS,
        variables: { donorScheduleDate, fertSiteId },
      }),
    }),
    getTravelingTechs: build.query({
      query: () => ({
        document: FERTILIZATION_TECHS,
      }),
      providesTags: ['TravelingTechs'],
    }),
    getFertTechs: build.query({
      query: ({ fertSiteId }) => ({
        document: FERTILIZATION_TECHS,
        variables: { fertSiteId },
      }),
      providesTags: ['TravelingTechs'],
    }),
    getFertilizationDonorSchedules: build.query({
      query: ({ donorScheduleDate, fertSiteId }) => ({
        document: FERTILIZATION_DONOR_SCHEDULE,
        variables: { donorScheduleDate, fertSiteId },
      }),
    }),
    getFertilizationPulledSemen: build.query({
      query: ({ donorScheduleDate, fertSiteId }) => ({
        document: PULLED_SEMEN,
        variables: { donorScheduleDate, fertSiteId },
      }),
    }),
    getFertilizationScheduledDonors: build.query({
      query: ({ semenID, donorScheduleDate, semenType, accountID }) => ({
        document: SCHEDULED_DONORS,
        variables: { semenID, donorScheduleDate, semenType, accountID },
      }),
    }),
    upsertReverseSort: build.mutation({
      query: (variables) => ({
        document: UPSERT_REVERSE_SORT,
        variables,
      }),
    }),
    createFertilization: build.mutation({
      query: (variables) => ({
        document: CREATE_FERTILIZATION,
        variables,
      }),
    }),
  }),
});
export const {
  useGetInlineFertCommentsQuery,
  useGetFertilizationSitesQuery,
  useGetFertCommentsQuery,
  useGetCreatedFertsQuery,
  useGetTravelingTechsQuery,
  useGetFertTechsQuery,
  useGetFertilizationDonorSchedulesQuery,
  useGetFertilizationPulledSemenQuery,
  useLazyGetFertilizationScheduledDonorsQuery,
  useUpsertReverseSortMutation,
  useCreateFertilizationMutation,
} = fertilizationAppApi;
